// eslint-disable-next-line import/prefer-default-export
export const openRebookingInformationModal = ({ openModal, types, isClosable }) =>
    openModal({
        type: types.rebookingInformation,
        props: {
            title: 'Repeat bookings for next year',
            subtitles: ['About the process', 'Outline of changes'],
            isClosable
        }
    });
